<div 
  role="group"
  [formGroup]="formGroup"
  attr.aria-describedby="describedBy"
  [attr.aria-labelledby]="parentFormField?._labelId"
  class="time-range-picker-container" [ngClass]="{'hide': !this.focused && 
    (this.formGroup.get('timeStart').value == null || this.formGroup.get('timeStart').value.length == 0) &&
    (this.formGroup.get('timeEnd').value == null || this.formGroup.get('timeEnd').value.length == 0) }">
    <div class="start-time-wrapper"><input matInput type="time" placeholder="Start hour" formControlName="timeStart"/></div>
    <span>–</span>
    <div class="end-time-wrapper"><input matInput type="time" placeholder="End hour" formControlName="timeEnd"/></div>
</div>

